import React, { useContext } from 'react';
import { ErrorDisplay } from './error-display';
import { FloatTextArea } from 'ui-components/components/float-text-area';
import messages from '../messages';
import style from '../style.module.less';
import { BatchByOrderCountRadioOption } from './batch-by-order-count-radio-option';
import { BatchByBatchCountRadioOption } from './batch-by-batch-count-radio-option';
import { FormattedMessage } from 'react-intl';
import { AutoBatchingContext } from '../context';

const InputReadyModalContent = () => {
  const { hasError, batchNotes, setBatchNotes } = useContext(AutoBatchingContext);

  return (
    <>
      {hasError && <ErrorDisplay />}
      <BatchByOrderCountRadioOption />
      <BatchByBatchCountRadioOption />
      <div className={style['param-input']}>
        <div className={style.label}>
          <FormattedMessage {...messages.autoBatchingNotesForBatch} />
        </div>
        <div>
          <FloatTextArea onChange={setBatchNotes} value={batchNotes} />
        </div>
      </div>
    </>
  );
};

export { InputReadyModalContent };
